export default __webpack_public_path__ + "static/media/59.568bbd5f.svg";